import type { ComponentProps } from "react";
import { useMemo } from "react";

import type { OverlayHook } from "app/pages/sales-intelligence/common-components/overlay-hook";
import { OVERLAY_MIN_HEIGHT_BY_VARIANT } from "app/pages/sales-intelligence/common-components/overlay-hook";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";

type OverlayHookProps = Pick<ComponentProps<typeof OverlayHook>, "height" | "variant">;

type Result = {
    overlayHookProps: OverlayHookProps;
    rowsCount: number;
};

export function useGetTrialTableHookProps(rowHeight: number): Result {
    return useMemo(() => {
        const isVariantB = GrowthbookService.growthbookInstance.isOn(TestsNames.TRIAL_TABLE_HOOK);

        const variant = isVariantB ? "vertical" : "horizontal";
        const minHeight = OVERLAY_MIN_HEIGHT_BY_VARIANT[variant];

        const rowsCount = Math.ceil(minHeight / rowHeight);

        const overlayHookProps: OverlayHookProps = {
            variant,
            height: rowsCount * rowHeight + 1, // plus 1px to cover a border
        };

        return {
            overlayHookProps,
            rowsCount,
        };
    }, [rowHeight]);
}
